module.exports = __webpack_public_path__ + "img/SeededEucalyptus_08.6fce6147.png";